import { SingleSelectControl, getLabelDefault, getValueDefault, useLocalField } from "@dgs/core";
import { FC } from "react";

import { ContactAttributeOption } from "../shared/types";

interface Props {
	label: string;
	options: ContactAttributeOption[];
	onSelect: (option: ContactAttributeOption) => void;
}

export const ContactFilterAttributeSelect: FC<Props> = ({ label, options, onSelect }) => {
	const props = useLocalField(options, getLabelDefault, getValueDefault);

	return (
		<SingleSelectControl
			{...props}
			label={label}
			name="contactAttribute"
			onChange={(e) => e.target.value && onSelect(e.target.value)}
			value={null as ContactAttributeOption | null}
			clearable={true}
		/>
	);
};
